import React from "react";
import "./DigiHero.css"; // Import CSS for styling

const Plus= () => {
  return (
    <div className="digihero-container">
      <img
        src="assets/schemes/plus.png"
        alt="Digi Hero"
        className="digihero-image"
      />
    </div>
  );
};

export default Plus;
